export default () => {
  const kicks = [0, 1, 2, 0, 0];

  return kicks.map((kick, idx) => ({
    kick: kick,
    idx: idx
  }));
};



// WEBPACK FOOTER //
// src/shared/tools/fetal-movement-tracker/data.js